<template>
  <el-dialog
    :title="$t('deleteBusinessTableHis.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    center
  >
    <div style="text-align:center">
      <p>{{ $t('deleteBusinessTableHis.confirmDeleteTrack') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteBusinessTableHis.cancel') }}</el-button>
      <el-button type="primary" @click="deleteBusinessTableHis">{{ $t('deleteBusinessTableHis.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteBusinessTableHis } from '@/api/dev/businessTableHisApi'

export default {
  name: 'DeleteBusinessTableHis',
  data() {
    return {
      dialogVisible: false,
      deleteInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteInfo = { ...row }
    },
    async deleteBusinessTableHis() {
      try {
        await deleteBusinessTableHis(this.deleteInfo)
        this.$message.success(this.$t('deleteBusinessTableHis.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error('删除业务轨迹失败:', error)
      }
    }
  }
}
</script>